/**
 * CustomerIdentification
 * Provides identity validation based off information submitted for specific customer.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Question { 
    /**
     * The actual question presented.
     */
    prompt: string;
    /**
     * The identification element that pertains to the question.
     */
    type: string;
    /**
     * Possible answer to the generated question.
     */
    answer: Array<string>;
}

